export default __webpack_public_path__ + "static/media/Giuria e scrittori finalisti.27970dd3.jpg";